import { API_ROOT_URL } from "../../config";
import { createContext } from "react";

export const BatteryContext = createContext({});

export const batteryApiRequest = async ({
  path,
  method = "GET",
  data = null,
  formData = null,
  token,
}) => {
  try {
    const url = `${API_ROOT_URL}${path}`;
    const options = {
      method: method,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      body: data ? JSON.stringify(data) : formData,
    };
    if (!formData) {
      options.headers["Content-Type"] = "application/json";
    }
    const response = await fetch(url, options);
    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      return responseData;
    } else if (response.status >= 400 && response.status <= 499) {
      const responseData = await response.json();
      responseData["status"] = response.status;
      return responseData;
    } else if (response.status >= 500 && response.status <= 599) {
      let message = {
        error: "Server errors",
        error_description: "Server status 500",
      };
      message["status"] = response.status;
      message["error_description"] =
        "Ooops...!, Something went wrong please try after sometimes.";
      return message;
    }
  } catch (e) {
    let message = {
      error: "Network Error",
      error_description: `Not able to connect with the server`,
    };
    return message;
  }
};
